module.exports = __webpack_public_path__ + "static/media/HB.79afdf21.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/ministries/HB.svg
// module id = 244
// module chunks = 0